export default {
  jp: {
    error: {
      updateTarget: {
        required: '変更対象を選択してください。',
        notExist: '変更対象は存在しないか削除されています。最新の情報を確認してください。'
      },
      groupSmallId: {
        notExist: '変更先のグループ分類は存在しないか削除されています。最新の情報を確認してください。',
        existUnavailableServices: '変更後のグループ分類では現在利用可能なサービスが利用できなくなるため、変更できません。 利用できなくなるサービス : [##UNAVAILABLE_SERVICE_NAMES##]',
        required: '変更先のグループ分類を選択してください。',
        invalid: '変更先のグループ分類が不正です。'
      },
      beforGroupSmallId: {
        notExist: '現所属のグループ分類は存在しないか削除されています。最新の情報を確認してください。',
        required: '現所属のグループ分類を選択してください。',
        invalid: '現所属のグループ分類が不正です。'
      },
      companyId: {
        notExist: '変更先の会社は存在しないか削除されています。最新の情報を確認してください。',
        required: '変更先の会社を選択してください。',
        invalid: '変更先の会社が不正です。'
      },
      branchId: {
        notExist: '変更先の支社・支局／媒体は存在しないか削除されています。最新の情報を確認してください。',
        invalid: '変更先の支社・支局／媒体が不正です。'
      },
      accountIdList: {
        invalid: '変更対象(アカウント)が不正です。'
      },
      accountEntryIdList: {
        invalid: '変更対象(アカウント申請)が不正です。'
      }
    }
  },
  en: {
  }
}
